// Authentication Types
export interface User {
  id: string
  email: string
  firstName: string
  lastName: string
  role: UserRole
  permissions: string[]
  createdAt: string
  lastLogin?: string
}

export enum UserRole {
  ADMIN = 'admin',
  COMPLIANCE_OFFICER = 'compliance_officer',
  ANALYST = 'analyst',
  VIEWER = 'viewer',
}

export interface LoginCredentials {
  email: string
  password: string
}

export interface LoginResponse {
  access_token: string
  refresh_token: string
  user: User
}

export interface AuthState {
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  error: string | null
  // WhatsApp authentication state
  authRequestId: string | null
  whatsAppAuthStatus: 'idle' | 'pending' | 'authenticated' | 'expired' | 'error'
  isPolling: boolean
}

// WhatsApp Authentication Types
export interface WhatsAppAuthRequest {
  phone: string
}

export interface WhatsAppAuthResponse {
  success: boolean
  authRequestId: string
  message?: string
}

export interface WhatsAppAuthStatus {
  status: 'pending' | 'authenticated' | 'expired' | 'not_found'
  sessionId?: string
  user?: User
  access_token?: string
  refresh_token?: string
}

export interface WhatsAppPINVerification {
  phone: string
  pin: string
}

// Stored API Credentials (mapped to phone number)
export interface StoredApiCredentials {
  phone: string // Phone number as identifier
  apiToken: string // AML-Guard API token
  userId: string // User ID for API
  userName?: string // Display name
  company?: string // Company name
  createdAt: string // When credentials were stored
  lastUsed?: string // Last successful login
}

// Credential storage response
export interface CredentialStorageResult {
  success: boolean
  message?: string
  credentials?: StoredApiCredentials
}
